import { Box } from '@mui/material';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import NewsSection from '../components/NewsSection';
import StatisticsSection from '../components/StatisticsSection';
import AlumniSearchSection from '../components/AlumniSearchSection';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <HeroSection />
      <NewsSection />
      <StatisticsSection />
      <AlumniSearchSection />
      <Footer />
    </Box>
  );
};

export default LandingPage;
